import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import {
  GET_HORSE_RACING_CONTINUED_COUPONS_REQUEST,
  GET_HORSE_RACING_CONTINUED_COUPONS_SUCCESS,
  GET_HORSE_RACING_CONTINUED_COUPONS_FAILURE,
  GET_HORSE_RACING_WON_COUPONS_REQUEST,
  GET_HORSE_RACING_WON_COUPONS_SUCCESS,
  GET_HORSE_RACING_WON_COUPONS_FAILURE,
  GET_HORSE_RACING_LOST_COUPONS_REQUEST,
  GET_HORSE_RACING_LOST_COUPONS_SUCCESS,
  GET_HORSE_RACING_LOST_COUPONS_FAILURE,
  GET_HORSE_RACING_SAVED_COUPONS_REQUEST,
  GET_HORSE_RACING_SAVED_COUPONS_SUCCESS,
  GET_HORSE_RACING_SAVED_COUPONS_FAILURE,
  GET_HORSE_RACING_COUPON_SAVE_REQUEST,
  GET_HORSE_RACING_COUPON_SAVE_SUCCESS,
  GET_HORSE_RACING_COUPON_SAVE_FAILURE,
  GET_HORSE_RACING_COUPON_RENAME_REQUEST,
  GET_HORSE_RACING_COUPON_RENAME_SUCCESS,
  GET_HORSE_RACING_COUPON_RENAME_FAILURE,
  GET_HORSE_RACING_COUPON_DELETE_REQUEST,
  GET_HORSE_RACING_COUPON_DELETE_SUCCESS,
  GET_HORSE_RACING_COUPON_DELETE_FAILURE,
  GET_HORSE_RACE_COUPON_DETAIL_REQUEST,
  GET_HORSE_RACE_COUPON_DETAIL_SUCCESS,
  GET_HORSE_RACE_COUPON_DETAIL_FAILURE,
  GET_HORSE_RACE_COUPON_PRIZE_REQUEST,
  GET_HORSE_RACE_COUPON_PRIZE_SUCCESS,
  GET_HORSE_RACE_COUPON_PRIZE_FAILURE,
  SET_HORSE_RACING_COUPONS_ACTIVE_FILTERS,
  RESET_HORSE_RACING_COUPONS_PAGINATION,
  GET_HORSE_RACING_COMBINATIONS_REQUEST,
  GET_HORSE_RACING_COMBINATIONS_SUCCESS,
  GET_HORSE_RACING_COMBINATIONS_FAILURE,
  SET_HORSE_RACING_SCROLL_POSITION,
  VERIFY_TJK_COUPON_FAILURE,
  SET_COUPONS_FILTERS,
  CLEAR_COUPON_STATE,
  GET_HORSE_RACING_SYSTEM_DETAIL_REQUEST,
  GET_HORSE_RACING_SYSTEM_DETAIL_SUCCESS,
  GET_HORSE_RACING_SYSTEM_DETAIL_FAILURE
} from 'Store/constants';
import { couponPrizeResultsMapper } from 'Utils/horseRacesNameMapper';
import { catchTJKError } from 'Utils/catchTJKError';
import { TJK_COUPON_STATUSES } from 'Store/constants/horseRacing';
import {
  TIME_LAST_7_DAYS,
  TIME_LAST_1_MONTH,
  TIME_LAST_3_MONTHS,
  TIME_LAST_6_MONTHS,
  TIME_LAST_1_YEAR
} from 'Utils/timeConstants';
import { COUPONS_FILTERS } from 'Store/constants/sportTypes';
import { TIME_DEFAULT_START_DATE } from 'Store/constants/sportTypes';
import { openModal, closeModal } from 'Store/actions';
import { toggleHRBetSlip } from './betSlipActions';
import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import History from 'Store/history';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import qs from 'query-string';
import ProjectConfig from 'ProjectConfig';

const getFilterDates = filterName => {
  let startDate = TIME_LAST_7_DAYS;
  const endDate = new Date().getTime();
  switch (filterName) {
    case COUPONS_FILTERS.LAST_7_DAYS:
      startDate = TIME_LAST_7_DAYS;
      break;
    case COUPONS_FILTERS.LAST_1_MONTH:
      startDate = TIME_LAST_1_MONTH;
      break;
    case COUPONS_FILTERS.LAST_3_MONTHS:
      startDate = TIME_LAST_3_MONTHS;
      break;
    case COUPONS_FILTERS.LAST_6_MONTHS:
      startDate = TIME_LAST_6_MONTHS;
      break;
    case COUPONS_FILTERS.LAST_1_YEAR:
      startDate = TIME_LAST_1_YEAR;
      break;
    default:
      break;
  }
  return { startDate, endDate };
};

const getApi = (getState, isMultiple) => {
  const prefix = isMultiple ? 'coupons' : 'coupon';
  const programType = getState().horseRacing.coupons.activeFilters.programType;
  return programType === 1 ? ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon' : ProjectConfig.API_GATEWAY + `/product/fixodds/${prefix}`;
};

export const getContinuedCoupons = () => async (dispatch, getState) => {
  try {
    let pagination = getState().horseRacing.coupons.pagination;

    dispatch({
      type: GET_HORSE_RACING_CONTINUED_COUPONS_REQUEST,
    });

    const startDate = TIME_DEFAULT_START_DATE;
    const endDate = new Date().getTime();

    const res = await axios.get(`${getApi(getState, true)}?startDate=${startDate}&endDate=${endDate}&status=${TJK_COUPON_STATUSES.PLAYED}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`);

    catchTJKError(res.data);

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_HORSE_RACING_CONTINUED_COUPONS_SUCCESS,
      payload: res.data.body,
      pagination
    });
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACING_CONTINUED_COUPONS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getWonCoupons = () => async (dispatch, getState) => {
  try {
    let pagination = getState().horseRacing.coupons.pagination;
    let filterName = getState().horseRacing.coupons.activeFilters.filterName;
    const filterDates = getFilterDates(filterName);
    dispatch({
      type: GET_HORSE_RACING_WON_COUPONS_REQUEST
    });
    const res = await axios.get(`${getApi(getState, true)}?startDate=${filterDates.startDate}&endDate=${filterDates.endDate}&status=${TJK_COUPON_STATUSES.WON}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`);

    catchTJKError(res.data);

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };


    dispatch({
      type: GET_HORSE_RACING_WON_COUPONS_SUCCESS,
      payload: res.data.body,
      pagination
    });
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACING_WON_COUPONS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getLostCoupons = () => async (dispatch, getState) => {
  try {
    let pagination = getState().horseRacing.coupons.pagination;
    let filterName = getState().horseRacing.coupons.activeFilters.filterName;
    const filterDates = getFilterDates(filterName);
    dispatch({
      type: GET_HORSE_RACING_LOST_COUPONS_REQUEST
    });
    const res = await axios.get(`${getApi(getState, true)}?startDate=${filterDates.startDate}&endDate=${filterDates.endDate}&status=${TJK_COUPON_STATUSES.LOST}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`);

    catchTJKError(res.data);

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_HORSE_RACING_LOST_COUPONS_SUCCESS,
      payload: res.data.body,
      pagination
    });
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACING_LOST_COUPONS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getSavedCoupons = () => async (dispatch, getState) => {
  try {
    let pagination = getState().horseRacing.coupons.pagination;
    let filterName = getState().horseRacing.coupons.activeFilters.filterName;
    const filterDates = getFilterDates(filterName);
    dispatch({
      type: GET_HORSE_RACING_SAVED_COUPONS_REQUEST
    });
    const res = await axios.get(`${getApi(getState, true)}?startDate=${filterDates.startDate}&endDate=${filterDates.endDate}&status=${TJK_COUPON_STATUSES.SAVED}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`);

    catchTJKError(res.data);

    pagination = {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1
    };

    dispatch({
      type: GET_HORSE_RACING_SAVED_COUPONS_SUCCESS,
      payload: res.data.body,
      pagination
    });
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACING_SAVED_COUPONS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const saveTjkCoupon = () => async (dispatch, getState) => {
  try {
    dispatch(openModal('TJKcouponSaveLoader'));
    const programType = getState().horseRacing.allHippodromes.programType;
    let api;

    const {
      legs,
      selectedInfos: { selectedBet, selectedHippodrome, legsData, selectedRaceNumber }
    } = getState().horseRacing.betSlip;
    const { multiplier, allVariation, couponCount } = getState().horseRacing.betSlip.footerData;
    let selectedLegs = [];
    legs?.forEach(l => {
      if (l) {
        selectedLegs.push(l.map(el => el.horseNo.toString()));
      }
    });

    let requestBody = {
      cardId: selectedHippodrome?.cardId,
      betTypeId: selectedBet?.id,
      raceNumber: legsData[0]?.legNo,
      stake: multiplier * 1,
      complete: allVariation,
      couponCount: couponCount * 1,
      selectable: selectedRaceNumber,
      legs: selectedLegs.map(sl => sl.join()),
      akey: selectedHippodrome?.akey,
      programDate: new Date(selectedHippodrome?.raceDate)?.getTime()
    };

    dispatch({
      type: GET_HORSE_RACING_COUPON_SAVE_REQUEST
    });
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon/saved';
        break;
      case PROGRAM_TYPES.FIXED:
        // eslint-disable-next-line no-case-declarations
        const propositionInfo = legs?.filter(l => l?.length > 0)[0][0]?.propositionInfo;
        requestBody = { ...requestBody, propositionId: propositionInfo.propositionId, fixedOdd: propositionInfo.odd };
        api = ProjectConfig.API_GATEWAY + '/product/fixodds/coupon/save';
        break;
      default:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon/saved';
        break;
    }
    const res = await axios.post(api, requestBody);

    catchTJKError(res.data);

    dispatch({
      type: GET_HORSE_RACING_COUPON_SAVE_SUCCESS,
      payload: res.data
    });

    dispatch(closeModal('TJKcouponSaveLoader'));
    dispatch(openModal('TjkSaveCouponSuccessModal', { couponId: res.data.body.couponId }));
    return { success: true };

  } catch (e) {
    dispatch(closeModal('TJKcouponSaveLoader'));
    dispatch(openModal('tjkPlayCouponFailureModal', { error: e, errorTitle: 'Kuponunuz Kaydedilemedi' }));
    dispatch({
      type: GET_HORSE_RACING_COUPON_SAVE_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });

    if (e?.code === 1007 && e?.domain === 'tjk-mobile-bff') { //save koşmaz at yakalanırsa betslip verfiy hatası da tetiklenir.
      dispatch({
        type: VERIFY_TJK_COUPON_FAILURE,
        payload: e.response?.data || (e.message ? e : errorMessage),
      });
    }

    return { success: false };
  }
};

export const renameSavedCoupon = (body, fromBetSlip) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HORSE_RACING_COUPON_RENAME_REQUEST
    });
    const programType = getState().horseRacing.allHippodromes.programType;
    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon/saved/rename';
        break;
      case PROGRAM_TYPES.FIXED:
        api = ProjectConfig.API_GATEWAY + '/product/fixodds/coupon/rename';
        break;
      default:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon/saved/rename';
        break;
    }
    const res = await axios.put(api, body);

    catchTJKError(res.data);

    if (fromBetSlip) {
      dispatch(closeModal('TjkSaveCouponSuccessModal'));
      dispatch(toggleHRBetSlip(true));
    } else {
      dispatch(closeModal('tjkCouponRenameModal'));
    }

    dispatch({
      type: GET_HORSE_RACING_COUPON_RENAME_SUCCESS,
      payload: res.data.body
    });
    if (res.data.success) {
      if (!fromBetSlip) {
        const couponsState = getState().horseRacing.coupons;
        const renamedCoupons = couponsState.savedCoupons.coupons.find(sc => sc.couponId === body.couponId);
        renamedCoupons.name = body.name;
        dispatch(getCouponDetail(body.couponId));
      }
    } else {
      dispatch(openModal('tjkCouponRenameFailureModal'));
    }

  } catch (e) {
    dispatch(closeModal('tjkCouponRenameModal'));
    dispatch(openModal('tjkCouponRenameFailureModal'));
    dispatch({
      type: GET_HORSE_RACING_COUPON_RENAME_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage)
    });
  }
};

export const deleteSavedCoupon = requestBody => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HORSE_RACING_COUPON_DELETE_REQUEST
    });

    const pt = qs.parse(History?.location?.search)?.pt || 'joint';

    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon/saved';
    const res = await axios.delete(apiUrl, { data: requestBody });

    if (res.data.success) {
      dispatch(openModal('tjkCouponDeleteSuccessModal'));
    } else {
      dispatch(openModal('tjkCouponDeleteFailureModal'));
    }
    catchTJKError(res.data);
    dispatch({
      type: GET_HORSE_RACING_COUPON_DELETE_SUCCESS
    });


    /* dispatch(resetCouponsPagination(true, {
       filterName: 'LAST_7_DAYS',
       activeTab: 4,
       programType: 2
     }));*/

    dispatch(resetCouponsPagination(true, {
      filterName: 'LAST_7_DAYS',
      activeTab: 4,
      programType: pt === 'joint' ? 1 : 2
    }));

    // dispatch(getSavedCoupons());
    // Kayıtlı kuponlarım
    History.push(TJK_URL_SUFFIX.coupons.fullPage, { activeTabId: 4 });
  } catch (e) {
    dispatch(openModal('tjkCouponDeleteFailureModal'));
    dispatch({
      type: GET_HORSE_RACING_COUPON_DELETE_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage)
    });
  }
};

export const getCombinations = couponId => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACING_COMBINATIONS_REQUEST
    });

    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/coupon/${couponId}/combinations`;
    const res = await axios.get(apiUrl);

    catchTJKError(res.data);

    dispatch({
      type: GET_HORSE_RACING_COMBINATIONS_SUCCESS,
      payload: res.data.body
    });
    dispatch(openModal('combinationsModal', {
      combinations: [res.data.body.combinations]
    }));
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACING_COMBINATIONS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setActiveCouponsFilter = activeFilterName => async dispatch => {
  dispatch({
    type: SET_HORSE_RACING_COUPONS_ACTIVE_FILTERS,
    payload: activeFilterName
  });
};

export const getCouponDetail = couponId => async (dispatch, getState) => {
  const pt = qs.parse(History?.location?.search)?.pt || 'joint';
  let api;
  switch (pt) {
    case PROGRAM_TYPES.JOINT.toLowerCase():
      api = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon';
      break;
    case PROGRAM_TYPES.FIXED.toLowerCase():
      api = ProjectConfig.API_GATEWAY + '/product/fixodds/coupon';
      break;
    default:
      api = ProjectConfig.API_GATEWAY + '/mobile/tjk/coupon';
  }
  try {
    dispatch({
      type: GET_HORSE_RACE_COUPON_DETAIL_REQUEST
    });
    const res = await axios.get(`${api}/${couponId}`);

    if (res?.data?.success) {
      dispatch({
        type: GET_HORSE_RACE_COUPON_DETAIL_SUCCESS,
        payload: res.data.body
      });

      const { coupon } = res.data.body;
      const lastRaceNumber = coupon?.couponLegs[coupon?.couponLegs?.length - 1]?.raceNo;

      dispatch(getCouponPrizes(coupon.cardId, lastRaceNumber));
    } else {

      const errorCode = res?.data?.error?.code;
      if (errorCode && errorCode === 1006) {
        History.push('/404');
      } else {
        catchTJKError(res.data);
      }
    }


  } catch (e) {
    dispatch(openModal('tjkCouponDetailFailureModal'));
    dispatch(resetCouponsPagination(false));
    dispatch({
      type: GET_HORSE_RACE_COUPON_DETAIL_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getCouponPrizes = (cardId, lastRaceNumber) => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_COUPON_PRIZE_REQUEST
    });
    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/coupon/race/result?cardId=${cardId}&lastRaceNumber=${lastRaceNumber}`;
    const res = await axios.get(apiUrl);
    const payload = couponPrizeResultsMapper(res.data?.body?.raceResults);
    dispatch({
      type: GET_HORSE_RACE_COUPON_PRIZE_SUCCESS,
      payload: payload.raceResults
    });

    catchTJKError(res.data);

  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_COUPON_PRIZE_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const resetCouponsPagination = (scrollToTop, payload) => async dispatch => {
  if (scrollToTop) {
    document.getElementsByClassName('infinite-scroll-component')[0]?.scrollTo(0, 0);
  }
  dispatch({
    type: RESET_HORSE_RACING_COUPONS_PAGINATION,
    payload: payload
  });
};

export const setScrollPosition = scrollPosition => async dispatch => {
  dispatch({
    type: SET_HORSE_RACING_SCROLL_POSITION,
    payload: scrollPosition
  });
};

export const setCouponsFilter = data => async dispatch => {
  dispatch({
    type: SET_COUPONS_FILTERS,
    payload: data
  });
};

export const resetCouponsState = data => async dispatch => {
  dispatch({
    type: CLEAR_COUPON_STATE
  });
};

export const getSystemDetail = (couponId, source) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HORSE_RACING_SYSTEM_DETAIL_REQUEST
    });

    const apiUrl = `${ProjectConfig.API_GATEWAY}/product/fixodds/coupon/system/${couponId}`;
    const res = await axios.get(apiUrl);

    catchTJKError(res.data);

    dispatch({
      type: GET_HORSE_RACING_SYSTEM_DETAIL_SUCCESS,
      payload: { ...res.data.body, source }
    });
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACING_SYSTEM_DETAIL_FAILURE,
      payload: 'Kombinasyonlar yüklenemedi'
    });
  }
  dispatch(openModal('systemDetailModal'));
};
